import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"
import { cn } from "@/lib/utils"

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => {
  return (
    <SwitchPrimitives.Root
      className={cn(
        "switch-root peer group touch-target-pseudo relative inline-flex h-6 w-12 shrink-0 cursor-pointer items-center justify-start rounded-[0.25rem] border border-border/60 bg-surface-2 p-0 shadow-[inset_0_2px_4px_rgba(0,0,0,0.35)]",
        "transition-[background-color,border-color,box-shadow,transform] duration-150 ease-out",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "hover:border-border active:scale-95",
        className
      )}
      {...props}
      ref={ref}
    >
      <SwitchPrimitives.Thumb
        className={cn(
          "pointer-events-none relative z-10 block h-5 w-5 rounded-[2px] border ring-0",
          "transition-[transform,background-color,border-color,box-shadow] duration-150 ease-out",
          "data-[state=unchecked]:translate-x-0.5 data-[state=unchecked]:border-foreground/50 data-[state=unchecked]:bg-foreground/70 data-[state=unchecked]:shadow-[0_1px_2px_rgba(0,0,0,0.35)]",
          "data-[state=checked]:translate-x-6 data-[state=checked]:border-[var(--color-primary-hover)] data-[state=checked]:bg-[var(--color-primary-hover)] data-[state=checked]:shadow-[0_0_4px_var(--color-primary-hover)]"
        )}
      />
    </SwitchPrimitives.Root>
  );
})
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
